import React, { useState } from 'react';

export default function ConfirmModal({
  isOpen,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'primary',
  requireTypeText,
  onConfirm,
  onCancel,
  busy = false,
}) {
  const [typed, setTyped] = useState('');

  if (!isOpen) return null;

  const confirmDisabled = busy || (requireTypeText && typed !== requireTypeText);
  const confirmClasses = variant === 'danger'
    ? 'bg-tomato-600 hover:bg-tomato-700 active:bg-tomato-800 text-white'
    : 'bg-tomato-500 hover:bg-tomato-600 active:bg-tomato-700 text-white';

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-title"
      className="fixed inset-0 z-[1000] flex items-end sm:items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
      onClick={() => !busy && onCancel?.()}
    >
      <div
        className="w-full max-w-md glass-card p-6 space-y-4"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="confirm-title" className="text-lg font-semibold text-[color:var(--color-text-primary)]">
          {title}
        </h3>
        {message && (
          <p className="text-sm text-[color:var(--color-text-secondary)] leading-relaxed">
            {message}
          </p>
        )}
        {requireTypeText && (
          <>
            <p className="text-sm text-[color:var(--color-text-primary)]">
              Type <strong>{requireTypeText}</strong> to confirm:
            </p>
            <input
              className="w-full px-3 py-2 rounded-lg bg-transparent border border-[color:var(--glass-border)] focus:border-[color:var(--color-accent)] focus:outline-none text-[color:var(--color-text-primary)]"
              type="text"
              value={typed}
              onChange={(e) => setTyped(e.target.value)}
              placeholder={requireTypeText}
              autoComplete="off"
              disabled={busy}
            />
          </>
        )}
        <div className="flex flex-col-reverse sm:flex-row gap-2 pt-2">
          <button
            type="button"
            className="flex-1 px-4 py-2.5 rounded-lg font-medium border border-[color:var(--glass-border)] text-[color:var(--color-text-primary)] hover:bg-[color:var(--color-bg-elevated)] transition-colors disabled:opacity-50"
            onClick={() => onCancel?.()}
            disabled={busy}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`flex-1 px-4 py-2.5 rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${confirmClasses}`}
            onClick={() => onConfirm?.()}
            disabled={confirmDisabled}
          >
            {busy ? 'Working…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
